import { Directive, HostListener, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import type { ComponentType } from "@angular/cdk/portal";
import { SignalFormDialogComponent } from "./signal-form-dialog-component/signal-form-dialog-component.component";

@Directive({
  selector: "[libSignalFormDialog]",
})
export class SignalFormDialogDirective<T> {
  #matDialog = inject(MatDialog);

  // Signal Inputs
  // Flavor Text
  $dialogTitle = input<string>("Form Dialog Title", { alias: "dialogTitle" });
  $submitButtonText = input<string>("Submit", { alias: "submitButtonText" });
  $closeButtonText = input<string>("Close", { alias: "cancelButtonText" });
  // Dialog Dimensionals
  $dialogWidth = input<string>("100%", { alias: "dialogWidth" });
  $dialogMaxWidth = input<string>("500px", { alias: "dialogMaxWidth" });
  $dialogHeight = input<string>("auto", { alias: "dialogHeight" });
  $dialogMaxHeight = input<string>("auto", { alias: "dialogMaxHeight" });
  // Form Inputs
  $formComponent = input.required<ComponentType<any>>({ alias: "formComponent" });
  $initialData = input.required<T>({ alias: "initialData" });
  $isDisabled = input<boolean>(false, { alias: "disabled" });
  $otherInputs = input<Record<string, any>>({}, { alias: "otherInputs" });

  // Plain callback instead of output<T>() — this button is often a mat-menu-item, which gets
  // destroyed as soon as the menu closes, well before the dialog it opened actually resolves.
  // A destroyed output() throws if emitted; a plain function call doesn't care.
  $formOutput = input<((val: T) => void) | undefined>(undefined, { alias: "formOutput" });

  @HostListener("click")
  open() {
    const dialogRef = this.#matDialog.open(SignalFormDialogComponent, {
      width: this.$dialogWidth(),
      maxWidth: this.$dialogMaxWidth(),
      height: this.$dialogHeight(),
      maxHeight: this.$dialogMaxHeight(),
      data: {
        title: this.$dialogTitle(),
        closeLabel: this.$closeButtonText(),
        submitLabel: this.$submitButtonText(),
        formComponent: this.$formComponent(),
        formInput: this.$initialData(),
        otherInputs: this.$otherInputs(),
        disabled: this.$isDisabled(),
      },
    });

    dialogRef.afterClosed().subscribe((val) => {
      if (val) this.$formOutput()?.(val);
    });
  }
}
